import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DBasicosParametricasServicios, DValorDominio, DValorPeriodico } from '@dian/api-basicos-parametricas';
import { DirectionType, HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { DRenta210v18Servicios, DVencimiento } from '@dian-api/renta210v18';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';
import { MessageObservableService } from '../../../../../../services/message-observable.service';


const stepsList = [
  { text: "1", active: false, completed: false, tooltip: '', listHelp: ['817'] },
  { text: "2", active: true, completed: false, tooltip: ' ', listHelp: ['817'] }
];

class Form1 {
  id: number;
  patrimonioLiqAnioAnt: string;
  ultDecPresExt: string;
  ultDecPresExtNombre: string;
  fechaPresDecla: Date = new Date();
  valItem: string;
}

@Component({
  selector: 'app-sancion-modal',
  templateUrl: './sancion-modal.component.html',
  styleUrls: ['./sancion-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DRenta210v18Servicios,
    DBasicosParametricasServicios
  ]
})
export class SancionComponent extends HandlerModal implements OnInit {

  public modelForm: Form1 = new Form1();
  public listaAniosExtemporaneidad: DValorDominio[] = [];
  public valUVT: string = "0";
  public vencimiento: DVencimiento = new DVencimiento();
  public valSancion: string = "0";
  public isFormVisible: boolean = false;
  public mensajeTabla = "¿Su declaración de renta está fuera de la fecha de vencimiento?";
  public cantMonths: number = 0;
  public model210: DDocumento = new DDocumento();

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<SancionComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    public dRenta210: DRenta210v18Servicios,
    public sugeridaService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento,
    private _messagesObs: MessageObservableService,
    private dBasicosParametricasServicios: DBasicosParametricasServicios
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
  }

  ngOnInit() {
    this.getUVT();
    this.listenMessage();
    this._messagesObs.sendMessages('calcular129', '');
  }

  protected controlStep(direction: DirectionType): void { }

  private listenMessage() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'calculado129') {
        this.inicializeModelo();
        this.getVencimiento();
      }
    });
  }

  private getVencimiento() {
    
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dRenta210.obtenerVencimiento(this.model.doc.cab.cs_id_5,this.model.doc.cab.cs_id_1).subscribe(
      (res: DVencimiento) => {
        this.vencimiento = <DVencimiento>res;
        this.calculateOcultas();
        this.inicializeForm();
        preloader.close();
      },
      error => {
        preloader.close();
        this.dNotificacionServicio.mostrarDialogoError('Error obteniendo el vencimiento', error.mensaje);
      });
  }

  private getUVT(): void {
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    const year = new Date().getFullYear();
    this.dBasicosParametricasServicios.obtenerValorPeriodico(110, year).subscribe(
      (data: DValorPeriodico) => {
        preloader.close();
        this.valUVT = String(data.valor);
      },
      error => {
        preloader.close();
        this.dNotificacionServicio.mostrarDialogoError('Error obteniendo las UVT', error.mensaje);
      }
    );
  }

  protected inicializeForm() {
    const patriLiq = this.sugeridaService.getDataArrFromMap(['VAR_321']);
    const valPatriLiq = patriLiq && patriLiq.length ? patriLiq[0].item.value[0] : '0';
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.patrimonioLiqAnioAnt = valPatriLiq.toString();
    this.modelForm.ultDecPresExt = "";
    this.modelForm.fechaPresDecla = new Date();
    this.modelForm.valItem = "0";
  }

  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_812 == undefined) {
      this.model.doc.cuerpo.cc_id_812 = [];
      this.model.doc.cuerpo.cc_id_817 = [];
      this.model.doc.cuerpo.cc_id_818 = [];
      this.model.doc.cuerpo.cc_id_819 = [];
    }
  }

  public validateFormCompleted(): boolean {
    return !this.modelForm.patrimonioLiqAnioAnt ||
      !this.modelForm.ultDecPresExt ||
      !this.modelForm.fechaPresDecla ||
      !this.modelForm.valItem;
  }

  public redondearFormData() {
    this.modelForm.valItem = this.dutilidades.redondearValorMoneda(this.modelForm.valItem.toString(), true);
  }

  saveItem(): void {
    if (this.validateFormCompleted()) {
      this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    }

    //Recalcular y reinicializar
    this.operacionCs819();
    this.inicializeForm();
    this.isFormVisible = false;
  }

  showForm(): void {
    this.isFormVisible = true;
  }

  cancel(): void {
    this.inicializeForm();
    this.cleanOcultas();
    this.isFormVisible = false;
  }

  operacionCs819() {
    this.calculateOcultas();

    if (!this.vencimiento.esExtemporaneo && this.cantMonths === 0) {
      this.valSancion = "0";
      return;
    }

    this.valSancion = "0";
    const cas129 = this.getValueCas('cs_id_129', false);
    const cas129x05 = this.mathOp(cas129, "*", "0.05");
    const cas823 = String(this.cantMonths);//this.getValueCas('cc_id_823');
    const cas129x05x823 = this.mathOp(cas129x05, "*", cas823);
    const minUVT = this.mathOp(this.valUVT, "*", "10");
    const val2500uvt = this.mathOp(this.valUVT, "*", "2500");
    const cas137 = this.getValueCas('cs_id_137', false);
    const cas137x2 = this.mathOp(cas137, "*", "2");    

    //PRIMER FLUJO
    if (
      this.mathValidation(cas129, ">", "0") &&
      this.mathValidation(cas129x05x823, "<", cas129)
    ) {
      this.valSancion = cas129x05x823;
    } else {
      const fieldsToSum = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74', 'cs_id_99', 'cs_id_104', 'cs_id_107', 'cs_id_108', 'cs_id_109', 'cs_id_112']
      let totalFields = '0';

      for (const item of fieldsToSum) {
        const val = this.model.doc.cuerpo[item];
        totalFields = this.mathOp(totalFields, "+", val);
      }        

      let valueToCompare = "0";
      valueToCompare = this.mathValidation(cas137x2, "=", "0") ? val2500uvt : cas137x2;

      //SEGUNDO FLUJO
      if (this.mathValidation(cas129, "=", "0") && this.mathValidation(totalFields, ">", "0")) {
        const totalFieldsx05 = this.mathOp(totalFields, "*", "0.05");
        const totalFieldsx005 = this.mathOp(totalFields, "*", "0.005");
        const totalFieldsx005x823 = this.mathOp(totalFieldsx005, "*", cas823);

        if (this.mathValidation(totalFieldsx05, "<=", valueToCompare))
          valueToCompare = totalFieldsx05;

        if (this.mathValidation(totalFieldsx005x823, "<=", valueToCompare))
          valueToCompare = totalFieldsx005x823;

        this.valSancion = valueToCompare;
      }

      let cas812 = this.modelForm.patrimonioLiqAnioAnt;
      if (!cas812) cas812 = this.getValueCas('cc_id_812');

      //TERCER FLUJO
      if (
        this.mathValidation(cas129, "=", "0") &&
        this.mathValidation(totalFields, "=", "0") &&
        this.mathValidation(cas812, ">", "0")
      ) {
        const cas812x01 = this.mathOp(cas812, "*", "0.01");
        const cas812x01x823 = this.mathOp(cas812x01, "*", cas823);
        const cas812x1 = this.mathOp(cas812, "*", "0.1");

        if (
          this.mathValidation(cas812x01x823, "<=", cas812x1) && 
          this.mathValidation(cas812x01x823, "<=", cas137x2)
        )
          valueToCompare = cas812x01x823;

        if (this.mathValidation(cas812x01x823, "<=", val2500uvt))
          valueToCompare = cas812x01x823;

        this.valSancion = valueToCompare;
      }

    }

    if (this.mathValidation(this.valSancion, '>', '0')) {
      if (this.modelForm.ultDecPresExt == '2') {
        this.valSancion = this.mathOp(this.valSancion, '/', '2');        
      } else if (this.modelForm.ultDecPresExt == '1') {
        this.valSancion = this.mathOp(this.valSancion, '*', '0.75');
      }
    }

    //Si el valor de la sanción es menor a 10 UVT se cobra las 10 UVT si no se deja el valor calculado
    if (this.mathValidation(this.valSancion, "<", minUVT))
      this.valSancion = minUVT;
    
    if (
      this.mathValidation(this.valSancion, ">", val2500uvt) &&
      this.mathValidation(cas137x2, "=", '0')
    )
      this.valSancion = val2500uvt;

    this.valSancion = this.dutilidades.redondearValorMoneda(this.valSancion);
    this.modelForm.valItem = this.valSancion;
    this.model.doc.cuerpo.cs_id_819 = this.valSancion;
  }

  calculateOcultas() {
    //fecha de vencimiento funciona para el mismo año
    //const limitDate = Number(this.vencimiento.fechaLimite);
    // //número de meses o fracción de año
    // const date = this.modelForm.fechaPresDecla ? new Date(this.modelForm.fechaPresDecla) : new Date();//new Date(this.modelForm.fechaPresDecla.toString());
    // const today = Number(date.toISOString().substring(0, 10).split("-").join(""));
    // const months = Math.ceil((today - limitDate) / 100).toString();
    // const valueMonths = Number(months) > 0 ? months : '0';
    // this.cantMonths = Number(valueMonths);
    
    const startDate = this.getFormatDate(String(this.vencimiento.fechaLimite));
    const dateSelected = this.modelForm.fechaPresDecla ? new Date(this.modelForm.fechaPresDecla) : new Date();
    const endDate = dateSelected.toISOString().split('T')[0];
    const diffMonths = this.getDiffMonths(startDate, endDate);
    const valueMonths = diffMonths > 0 ? String(diffMonths) : '0';
    this.cantMonths = Number(valueMonths);

    this.model.doc.cuerpo.cc_id_822 = [{ it: 1, v: this.vencimiento.fechaLimite }];
    this.model.doc.cuerpo.cc_id_823 = [{ it: 1, v: valueMonths }];
  }

  private getFormatDate(value: string): string {
    const year = parseInt(value.substring(0, 4), 10);
    const month = parseInt(value.substring(4, 6), 10);
    const day = parseInt(value.substring(6, 8), 10);
    return `${year}-${month}-${day}`;
  }

  private getDiffMonths(startDate: string, endDate: string): number {
    const inicio = new Date(startDate);
    const fin = new Date(endDate);
    const aniosDiferencia = fin.getFullYear() - inicio.getFullYear();
    let mesesDiferencia = fin.getMonth() - inicio.getMonth();
    // Ajustar la diferencia de meses si el día de la fecha fin es menor que el día de la fecha inicio
    if (fin.getDate() < inicio.getDate()) mesesDiferencia--;
    // Calcular la cantidad total de meses
    let totalMeses = (aniosDiferencia * 12) + mesesDiferencia;
    if (fin.getDate() > inicio.getDate()) totalMeses++;
    return totalMeses;
  }

  private cleanOcultas() {
    this.model.doc.cuerpo.cc_id_822 = [];
    this.model.doc.cuerpo.cc_id_823 = [];
  }

  private getValueCas(idCas: string, is2100: boolean = true) {
    let sum = "0";
    const dataCas = is2100 ? this.model.doc.cuerpo[idCas] : this.model210.doc.cuerpo[idCas];
    if (dataCas && Array.isArray(dataCas) && dataCas.length) {
      for (const subItem of dataCas)
        sum = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, subItem.v, sum);
    } else {
      if (dataCas && !Array.isArray(dataCas))
        return dataCas;
      return sum;
    }
    return sum;
  }

  private mathOp(val1: string, op: string, val2: string): string {
    switch (op) {
      case "+":
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, val1, val2);
      case "-":
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, val1, val2);
      case "*":
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, val1, val2);
      case "/":
        return this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, val1, val2);
    }
  }

  private mathValidation(val1: string, op: string, val2: string): boolean {
    switch (op) {
      case ">":
        return this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, val1, val2);
      case ">=":
        return this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, val1, val2);
      case "<":
        return this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, val1, val2);
      case "<=":
        return this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, val1, val2);
      case "=":
        return this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, val1, val2);
    }
  }

  validateSancion() {
    if (this.mathValidation(this.modelForm.valItem, '<', this.valSancion)) {
      this.dNotificacionServicio.mostrarDialogoInformacion('El valor no puede ser menor a la sanción calculada.')
        .afterClosed().subscribe(res => {
          this.modelForm.valItem = this.valSancion;
        });
    }
  }

  closeModal() {
    this.dialogRef.close("");
  }

  guardar() {
    this.saveModel.emit(true);
    this.closeModal();
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/sancion-modal/sancion-modal.component.ts